import React from 'react';
import styled from 'styled-components';
import {
  fontSize,
  fontWeights,
  minBreakpointQuery,
  sectionMargins,
} from '../styles';
import { Container } from './ui';

const StyledFeaturedLogos = styled.section`
  ${sectionMargins()};
`;

const StyledContainer = styled(Container)`
  padding-left: 0;
  padding-right: 0;
`;

const StyledHeading = styled.h2`
  text-align: center;
  font-weight: ${fontWeights.regular};
  ${fontSize(18)}

  ${minBreakpointQuery.small`
    ${fontSize(22)}
  `}

  ${minBreakpointQuery.large`
    ${fontSize(26)}
  `}
`;

const StyledImages = styled.div`
  overflow-y: scroll;
  display: flex;
  justify-content: space-between;
  gap: 30px;
  width: 100%;
  margin-top: 30px;
  padding: 0 30px;
  -ms-overflow-style: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }

  ${minBreakpointQuery.small`
    margin-top: 40px;
  `}

  ${minBreakpointQuery.large`
    margin-top: 50px;
  `}
`;

const StyledImage = styled.img`
  max-width: 65px;
  max-width: 130px;
`;

const FeaturedLogos = ({ heading, items }) => (
  <StyledFeaturedLogos>
    <StyledContainer>
      <StyledHeading>{heading}</StyledHeading>
      <StyledImages>
        {items.map(({ alt, url }, id) => (
          <StyledImage key={id} src={url} alt={alt} loading="lazy" />
        ))}
      </StyledImages>
    </StyledContainer>
  </StyledFeaturedLogos>
);

export default FeaturedLogos;
